import e, { OPTIONS as L } from "../../managers/braze-instance.js";
import ControlMessage from "../models/control-message.js";
import HtmlMessage from "../models/html-message.js";
import InAppMessage from "../models/in-app-message.js";
import SlideUpMessage from "../models/slide-up-message.js";
import me from "../display/get-animation-effect.js";
import ce from "../display/in-app-message-to-html.js";
import { logInAppMessageImpression } from "../log-in-app-message-impression.js";
import {
  ORIENTATION as fe,
  WindowUtils as eo,
} from "../../util/window-utils.js";
import { isURIJavascriptOrData as R } from "../../util/url-utils.js";
import { KeyCodes as mt } from "../../util/key-codes.js";
import { setupInAppMessageUI as ss } from "../../ui/js/index.js";
import { logger as r } from "../../../shared-lib/index.js";
import { toRgba as ie } from "../../util/color-utils.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as _ } from "../../common/constants.js";
import { isIFrame as It } from "../utils/in-app-message-utils.js";
import ue from "../../l10n/l10n-manager-factory.js";
export function showInAppMessage(t, o, s) {
  if (!e.X()) return;
  if ((ss(), null == t)) return !1;
  if (t instanceof ControlMessage)
    return (
      r.info(
        "User received control for a multivariate test, logging to Braze servers.",
      ),
      logInAppMessageImpression(t),
      !0
    );
  if (!(t instanceof InAppMessage)) return !1;
  if (t.constructor === InAppMessage) return !1;
  t.Nh();
  const i = t instanceof HtmlMessage;
  if (i && !t.trusted && !e.tr())
    return (
      r.error(
        'HTML in-app messages are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these messages.',
      ),
      !1
    );
  if ((null == o && (o = document.body), t.$e())) {
    if (o.querySelectorAll(".ab-modal-interactions").length > 0)
      return (
        r.info(
          `Cannot show in-app message ${t.message} because another message is being shown.`,
        ),
        !1
      );
  }
  if (eo.fo()) {
    const e = eo.co();
    if (
      (e === fe.PORTRAIT &&
        t.orientation === InAppMessage.Orientation.LANDSCAPE) ||
      (e === fe.LANDSCAPE &&
        t.orientation === InAppMessage.Orientation.PORTRAIT)
    ) {
      const o = e === fe.PORTRAIT ? "portrait" : "landscape",
        s =
          t.orientation === InAppMessage.Orientation.PORTRAIT
            ? "portrait"
            : "landscape";
      return (
        r.info(
          `Not showing ${s} in-app message ${t.message} because the screen is currently ${o}`,
        ),
        !1
      );
    }
  }
  if (!e.tr()) {
    let e = !1;
    if (t.buttons && t.buttons.length > 0) {
      const o = t.buttons;
      for (let t = 0; t < o.length; t++)
        if (o[t].clickAction === InAppMessage.ClickAction.URI) {
          const s = o[t].uri;
          e = R(s);
        }
    } else t.clickAction === InAppMessage.ClickAction.URI && (e = R(t.uri));
    if (e)
      return (
        r.error(
          'Javascript click actions are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these actions.',
        ),
        !1
      );
  }
  const n = document.createElement("div");
  if (
    ((n.className = "ab-iam-root v3"),
    (n.className += me(t)),
    n.setAttribute("role", "complementary"),
    t.Ce() && (n.id = t.htmlId),
    e.nn(L.jo) && (n.style.zIndex = (e.nn(L.jo) + 1).toString()),
    o.appendChild(n),
    t.ve())
  ) {
    const o = document.createElement("style");
    (o.innerHTML = t.css),
      (o.id = t.we()),
      null != e.nn(L.bo) && o.setAttribute("nonce", e.nn(L.bo)),
      document.getElementsByTagName("head")[0].appendChild(o);
  }
  const a = t instanceof SlideUpMessage,
    l = ce(
      t,
      () => {
        import("../../Feed/ui/show-feed.js").then((t) => {
          e.so() ? t.showFeed() : r.error(_);
        });
      },
      (o) => {
        if (t.$e() && t.do()) {
          const s = document.createElement("div");
          if (
            ((s.className = "ab-page-blocker"),
            t.ve() || (s.style.backgroundColor = ie(t.frameColor)),
            e.nn(L.jo) && (s.style.zIndex = e.nn(L.jo).toString()),
            n.appendChild(s),
            !e.nn(L.Lh))
          ) {
            const e = new Date().valueOf();
            s.onclick = (s) => {
              new Date().valueOf() - e > InAppMessage.fh &&
                (t.Cr(o), s.stopPropagation());
            };
          }
          n.appendChild(o), o.focus(), t.Oh(n);
        } else if (a) {
          const e = document.querySelectorAll(".ab-slideup");
          let s = null;
          for (let t = e.length - 1; t >= 0; t--)
            if (e[t] !== o) {
              s = e[t];
              break;
            }
          if (t.slideFrom === InAppMessage.SlideFrom.TOP) {
            let e = 0;
            null != s && (e = s.offsetTop + s.offsetHeight),
              (o.style.top = Math.max(e, 0) + "px");
          } else {
            let e = 0;
            null != s &&
              (e =
                (window.innerHeight || document.documentElement.clientHeight) -
                s.offsetTop),
              (o.style.bottom = Math.max(e, 0) + "px");
          }
        } else if (i && !e.nn(L.Lh)) {
          const e = t;
          It(o) &&
            o.contentWindow &&
            o.contentWindow.addEventListener("keydown", function (t) {
              t.keyCode === mt.mh && e.closeMessage();
            });
        }
        logInAppMessageImpression(t),
          t.dismissType === InAppMessage.DismissType.AUTO_DISMISS &&
            setTimeout(() => {
              n.contains(o) && t.Cr(o);
            }, t.duration),
          "function" == typeof s && s();
      },
      (e) => {
        r.info(e);
      },
      e.nn(L.ho),
      e.nn(L.jo),
      e.nn(L.bo),
      o,
      ue.m().wo(),
    );
  return (i || a) && (n.appendChild(l), t.Oh(n)), !0;
}
